<template>
  <div>
    <div>
      <div class="row col-12 q-mt-lg">
        <p class="text-brand-5 text-weight-bold texto-titulo">Atividades</p>
      </div>
      <div class="row col-6 q-ml-sm q-mb-md">
        <p class="text-brand-6">
          Selecione todas as atividades que serão executadas neste trabalho e
          siga com a coleta das respostas.
        </p>
      </div>
      <div class="col-12">
        <AvaliacaoRiscoLista
          :pt="pt"
          :usuarioPodeEditar="usuarioPodeEditar"
          @atividadesAtualizadas="atualizar()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, computed } from "@vue/runtime-core";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import AvaliacaoRiscoLista from "./AvaliacaoDeRiscoLista.vue";

export default {
  components: {
    AvaliacaoRiscoLista,
  },
  setup() {
    const route = useRoute();
    const store = useStore();
    const router = useRouter();
    const ptId = route.params.ptId;
    const pt = ref(false);
    const data = ref({
      inicio: "",
      final: "",
      emissao: "",
      local: "",
    });

    const buscarDetalhePt = async () => {
      store.dispatch("pdt/hiddenHeader", true);
      const resposta = await store.dispatch("pdt/buscarDetalhePt", { ptId });
      pt.value = resposta.data.resultado.dados;
    };

    const voltar = async () => {
      router.push({ name: "pdt-pt-detalhe" });
    };

    const usuarioPodeEditar = computed(() => {
      if (!pt.value) {
        return false;
      }

      return (
        store.getters["autenticacao/usuarioLogado"].id ===
        pt.value.emissorMatricula
      );
    });

    const atualizar = () => {
      buscarDetalhePt();
    };

    onMounted(buscarDetalhePt);
    return {
      pt,
      ptId,
      data,
      voltar,
      usuarioPodeEditar,
      atualizar,
    };
  },
};
</script>

<style>
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.cursor {
  cursor: pointer;
}
.texto-titulo {
  margin-left: 10px;
  font-size: 17px;
}
@media (max-width: 600px) {
  .texto-titulo {
    margin-left: 10px;
    font-size: 14px;
  }
}
</style>
